export default __webpack_public_path__ + "static/media/AS90-background.e79322d2.svg";